
/**
 * 使用方式，比如要获取username，就在页面上this.$store.state.user.username
 */
export default {
    namespaced: true, //开启命名空间
    state: () => ({
        initLink:''
    }),
    mutations: {
        setInitLink (state, initLink) {
            state.initLink = initLink
        }
    },
    actions: {},
    getters: {}
}
